import { render, staticRenderFns } from "./TrafficTypesTab.vue?vue&type=template&id=640a708e&scoped=true&"
import script from "./TrafficTypesTab.vue?vue&type=script&lang=js&"
export * from "./TrafficTypesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640a708e",
  null
  
)

export default component.exports